import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import Table from "components/shared/tables/Table";
import { useTable } from "components/shared/tables/Table/hooks/useTable";
import { useColumns } from "features/TraxxionProfile/sections/ExpectedHours/columns";
import useApi from "../../../../utils/api";

function ExpectedHours({ user }: any) {
    const { authGet } = useApi();
    const columns = useColumns({ edit: undefined, remove: undefined });

    const { data, isLoading } = useQuery({
        queryKey: [`/users/${user?.id}/expected-hours`],
        queryFn: ({ queryKey }: any) => authGet(queryKey[0]),
        enabled: !!user?.id,
    });

    const raw = useMemo(
        () => (Array.isArray(data) ? data : (data?.result ?? data?.data ?? [])),
        [data]
    );

    const table = useTable({
        data: raw,
        totalItems: raw.length,
        columns,
        loading: isLoading,
        enableRowSelection: false,
        enableSorting: false,
        pagination: false,
    });

    return (
        <div className="tw-overflow-hidden">
            <Table table={table} />
        </div>
    );
}

export default ExpectedHours;
